
import { useState, useEffect } from "react";
import { SecondOpinion } from "./SecondOpinion";
import { Canvas } from "fabric";
import { CustomCanvas } from "@/types/fabric";

interface ImageAnalysisProps {
  canvas: Canvas | null;
  activeTool?: string | null;
  currentDrawingId: string | null;
  onResetAnalysis?: (resetFn: () => void) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onToolChange?: (tool: string) => void;
}

export const ImageAnalysis = ({ 
  canvas, 
  activeTool, 
  currentDrawingId, 
  onResetAnalysis,
  isOpen,
  setIsOpen,
  onToolChange
}: ImageAnalysisProps) => {
  // Check if there's analysis data in the canvas whenever currentDrawingId changes
  useEffect(() => {
    if (canvas) {
      const canvasData = (canvas as CustomCanvas).data;
      if (canvasData?.analysisText) {
        // If analysis data exists, open the panel automatically
        console.log('Found analysis data in canvas, opening analysis panel');
        setIsOpen(true);
      }
    }
  }, [canvas, currentDrawingId, setIsOpen]); // Added setIsOpen to dependencies
  
  return (
    <SecondOpinion 
      canvas={canvas} 
      activeTool={activeTool} 
      currentDrawingId={currentDrawingId}
      onResetAnalysis={onResetAnalysis}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onToolChange={onToolChange}
    />
  );
};
